import { render, staticRenderFns } from "./index.vue?vue&type=template&id=398d8d26&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=398d8d26&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d8d26",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiModalVideo: require('/var/www/html/intelli.com.br/components/base/ui/ModalVideo.vue').default,BaseUiBreadcrumb: require('/var/www/html/intelli.com.br/components/base/ui/Breadcrumb.vue').default,BaseUiShareOnSocialMedias: require('/var/www/html/intelli.com.br/components/base/ui/ShareOnSocialMedias.vue').default,BaseUiGallery: require('/var/www/html/intelli.com.br/components/base/ui/Gallery.vue').default,BaseUiCardApplications: require('/var/www/html/intelli.com.br/components/base/ui/CardApplications.vue').default,BaseUiSlideIt: require('/var/www/html/intelli.com.br/components/base/ui/SlideIt.vue').default,BaseUiCardApplicationsTool: require('/var/www/html/intelli.com.br/components/base/ui/CardApplicationsTool.vue').default,BaseUiCardPublication: require('/var/www/html/intelli.com.br/components/base/ui/CardPublication.vue').default,BaseUiCardNews: require('/var/www/html/intelli.com.br/components/base/ui/CardNews.vue').default,BaseUiCardProduct: require('/var/www/html/intelli.com.br/components/base/ui/CardProduct.vue').default})
